/*
	Сохраняем параметры фильтрации приложений в localStorage
*/

export const setFilterParameters = (filter: string) => {
	localStorage.setItem("appsFilter", filter);
};

export const getFilterParameters = () => {
	return localStorage.getItem("appsFilter");
};
